import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const CreateShift = ({ visible, handleClose, initialData = '', onSubmit }) => {
    const formik = useFormik({
        enableReinitialize:true,
        initialValues: {
            shiftName: initialData?.shiftName || '',
            startTime: initialData?.startTime || '',
            endTime: initialData?.endTime || '',
        },
        validateOnMount: false,
        validateOnBlur: true,
        validationSchema: Yup.object({
            shiftName: Yup.string()
                .required('Shift Name is required'),
            startTime: Yup.string()
                .required('Start Time is required'),
            endTime: Yup.string()
                .required('End Time is required'),
        }),
        onSubmit: (values, { resetForm }) => {
            if (initialData?.shiftName) {
                onSubmit({
                    sp: "usp_UpdateShift",
                    solutionId: 1,
                    shiftName: values.shiftName,
                    startTime: values.startTime,
                    endTime: values.endTime,
                    shiftId: initialData?.shiftId,
                });
                onClose();
            } else {
                onSubmit({
                    sp: "usp_InsertShift",
                    solutionId: 1,
                    shiftName: values.shiftName,
                    startTime: values.startTime,
                    endTime: values.endTime,
                });
                onClose();
            }
        },
    });

    const onClose = () => {
        formik.resetForm();
        handleClose();
    };

    useEffect(() => {
        if (initialData?.shiftName) {
            formik.setFieldValue('shiftName', initialData.shiftName);
            formik.setFieldValue('startTime', initialData.startTime);
            formik.setFieldValue('endTime', initialData.endTime);
        }
    }, [initialData]);

    return (
        <Modal
            title={initialData ? "Edit Shift" : "Create New Shift"}
            visible={visible}
            onCancel={onClose}
            footer={null}
            destroyOnClose
            centered
            width={600}
            className="custom-modal-header p-0"
            maskClosable={false}
            
        >
            <form onSubmit={formik.handleSubmit}>
                <div className="" role="document">
                    <div>
                        <div className="row g-3">

                            <div className="col-md-12">
                                <label className="form-label ">Shift Name</label> <span className='text-danger'>*</span>
                                <input
                                    type="text"
                                    className="form-control form-control-md form-control-solid fs-7 bg-body-secondary"
                                    placeholder="Enter shift name"
                                    name="shiftName"
                                    value={formik.values.shiftName}
                                    onChange={formik.handleChange}
                                />
                                    {formik.touched.shiftName && formik.errors.shiftName && (
                                        <span style={{ color: 'red' }} role="alert">{formik.errors.shiftName}</span>
                                    )}

                            </div>

                            <div className="col-md-6">
                                <label className="form-label ">Start Time</label> <span className='text-danger'>*</span>
                                <input
                                    type="time"
                                    className="form-control form-control-md form-control-solid fs-7 bg-body-secondary"
                                    name="startTime"
                                    value={formik.values.startTime}
                                    onChange={formik.handleChange}
                                />
                                    {formik.touched.startTime && formik.errors.startTime && (
                                        <span style={{ color: 'red' }} role="alert">{formik.errors.startTime}</span>
                                    )}
                                <span style={{ color: 'red' }} role="alert"></span>
                            </div>

                            <div className="col-md-6">
                                <label className="form-label ">End Time</label> <span className='text-danger'>*</span>
                                <input
                                    type="time"
                                    className="form-control form-control-md form-control-solid fs-7 bg-body-secondary"
                                    name="endTime"
                                    value={formik.values.endTime}
                                    onChange={formik.handleChange}
                                />
                                    {formik.touched.endTime && formik.errors.endTime && (
                                        <span style={{ color: 'red' }} role="alert">{formik.errors.endTime}</span>
                                    )}                            </div>

                        </div>

                        <div className="modal-footer mt-3">
                            <button type="button" className="btn btn-light" onClick={onClose}>
                                Close
                            </button>
                            <button type="submit" className="btn btn-primary ms-3">
                                {initialData ? "Update" : "Add"}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </Modal>
    );
};

export default CreateShift;
